export function parseDurationToMinutes(input) {
  if (input == null) return null;
  const text = String(input).trim().toLowerCase();
  if (text === "") return null;

  const hourMatch = text.match(/(\d+(?:\.\d+)?)\s*(?:h|hr|hrs|hour|hours)/);
  const minMatch = text.match(/(\d+)\s*(?:m|min|mins|minute|minutes)/);

  let total = 0;
  if (hourMatch) total += Math.round(parseFloat(hourMatch[1]) * 60);
  if (minMatch) total += parseInt(minMatch[1], 10);

  if (!hourMatch && !minMatch) {
    const bare = text.match(/^\d+$/);
    if (bare) total = parseInt(bare[0], 10);
  }

  return total > 0 ? total : null;
}

export function minutesToDurationText(minutes) {
  if (!minutes || minutes <= 0) return "";
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  const parts = [];
  if (h > 0) parts.push(`${h} ${h === 1 ? "hour" : "hours"}`);
  if (m > 0) parts.push(`${m} ${m === 1 ? "minute" : "minutes"}`);
  return parts.join(" ");
}
